module.exports = __webpack_public_path__ + "img/logodz2.4e9b6e0c.png";